module.exports = __webpack_public_path__ + "7c9c7197d7c2b81ff495d19c6a83f055.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Tapered Baguette@2x.png
// module id = 332
// module chunks = 0